import { ErrorHandler, Injectable } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class CustomSentryErrorHandler extends ErrorHandler {
    private lastErrorTime = 0;
    private isHandlingError = false;
    private readonly ERROR_DIALOG_COOLDOWN = 30 *  60 * 1000; // Cooldown for 30 minutes

    // override handleError(error: any): void {

    //     // const eventId = Sentry.captureException(error);
    //     const eventId = Sentry.captureException(
    //         error instanceof Error
    //             ? error
    //             : new Error(error?.message || JSON.stringify(error))
    //     );

    //     let currentUser = null;
    //     // const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    //     try {
    //         const raw = localStorage.getItem("currentUser");
    //         currentUser = raw ? JSON.parse(raw) : null;
    //     } catch {
    //         console.warn('Invalid currentUser in localStorage');
    //     }

    //     const now = Date.now();

    //     if (this.isHandlingError) {
    //         return;
    //     }

    //     this.isHandlingError = true;
    //     try {

    //         if (error instanceof HttpErrorResponse && error.status === 401) {
    //                 console.warn('[401 Unauthorized]', error);
    //             return;
    //         }

    //         if (this.isExpressionChangedError(error)) {
    //             // Optional : local log
    //             console.warn('[Angular NG0100 ignored]', error);
    //             return;
    //         }

    //         // **Ignore Maximum call stack size exceeded errors for user dialog**
    //         if (this.isMaxCallStackError(error)) {
    //             console.warn('[Ignored Max Call Stack Error]', error);
    //             return; // exit early without showing dialog
    //         }


    //         const dialogErrorGap = now - this.lastErrorTime;
    //         if (this.shouldAskUserFeedback(error) && dialogErrorGap > this.ERROR_DIALOG_COOLDOWN) {
    //             this.lastErrorTime = now;
    //             Sentry.showReportDialog({
    //                 eventId,
    //                 user: {
    //                     name: currentUser.pd_user_name ? currentUser.pd_user_name : currentUser.pd_person_first_name + " " + currentUser.pd_person_last_name,
    //                     email: currentUser.user.email,
    //                 },
    //             });
    //         }

    //         super.handleError(error);
            
    //     } finally {
    //         this.isHandlingError = false;
    //     }
    // }

    override handleError(error: any): void {

        if (this.isHandlingError) return;
        this.isHandlingError = true;

        try {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                console.warn('[401 Unauthorized]', error);
                return;
            }

            if (this.isExpressionChangedError(error)) {
                console.warn('[Angular NG0100 ignored]', error);
                return;
            }

            if (this.isMaxCallStackError(error)) {
                console.warn('[Ignored Max Call Stack Error]', error);
                return;
            }

            let normalizedError = error instanceof Error
                ? error
                : new Error(error?.message || JSON.stringify(error));

            let eventId: string | undefined;

            try {
                eventId = Sentry.captureException(normalizedError);
            } catch (e) {
                console.error('Sentry failed', e);
            }

            let currentUser = null;
            try {
                const raw = localStorage.getItem("currentUser");
                currentUser = raw ? JSON.parse(raw) : null;
            } catch {
                console.warn('Invalid currentUser in localStorage');
            }

            const now = Date.now();

            const dialogErrorGap = now - this.lastErrorTime;

            if (
                eventId &&
                this.shouldAskUserFeedback(error) &&
                dialogErrorGap > this.ERROR_DIALOG_COOLDOWN
            ) {
                this.lastErrorTime = now;

                Sentry.showReportDialog({
                    eventId,
                    user: currentUser ? {
                        name: currentUser?.pd_user_name ||
                            `${currentUser?.pd_person_first_name || ''} ${currentUser?.pd_person_last_name || ''}`,
                        email: currentUser?.user?.email || '',
                    } : undefined
                });
            }

            super.handleError(error);

        } finally {
            this.isHandlingError = false;
        }
    }

    private shouldAskUserFeedback(error: any) {
        return !error?.status && !error?.isHandled;
    }

    private isExpressionChangedError(error: any): boolean {
        const message =
            error?.message ||
            error?.toString?.() ||
            '';
    
        return (
            message.includes('ExpressionChangedAfterItHasBeenCheckedError') ||
            message.includes('NG0100') ||
            message.includes('Previous value') && message.includes('Current value')
        );
    }

    private isMaxCallStackError(error: any): boolean {
        const message =
            error?.message ||
            error?.toString?.() ||
            '';

        return /maximum call stack size exceeded/i.test(message);
    }
}
